import * as React from 'react';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { useStoreState } from 'pullstate';
import { AppStore } from '../stores/AppStore.js';

const SnackbarAlert = () => {
    const { message, type, open, handleClose } = useStoreState(AppStore, s => s.snackbar);

    return (
        <Snackbar
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            open={open} autoHideDuration={3000} onClose={handleClose}>
            <Alert
                onClose={handleClose}
                severity={type}
                variant="filled"
                sx={{ width: '100%', whiteSpace: 'pre' }}
            >
                {message}
            </Alert>
        </Snackbar>
    );
}

export default SnackbarAlert;